export const FETCH_KEYWORD_RESEARCH_IN_PROGRESS = "FETCH_KEYWORD_RESEARCH_IN_PROGRESS";
export const FETCH_KEYWORD_RESEARCH_SUCCESSFUL = "FETCH_KEYWORD_RESEARCH_SUCCESSFUL";
export const FETCH_KEYWORD_RESEARCH_FAILED = "FETCH_KEYWORD_RESEARCH_FAILED";
export const CHANGE_SELECTED_RESEARCH_TYPE = "CHANGE_SELECTED_RESEARCH_TYPE";
